import { render, staticRenderFns } from "./RdwTable.vue?vue&type=template&id=c6027c9a&"
import script from "./RdwTable.vue?vue&type=script&lang=js&"
export * from "./RdwTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports